import { render, staticRenderFns } from "./EditableFormatSummariesSelector.vue?vue&type=template&id=248582c0&scoped=true&"
import script from "./EditableFormatSummariesSelector.vue?vue&type=script&lang=ts&"
export * from "./EditableFormatSummariesSelector.vue?vue&type=script&lang=ts&"
import style0 from "./EditableFormatSummariesSelector.vue?vue&type=style&index=0&id=248582c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248582c0",
  null
  
)

export default component.exports